module.exports = __webpack_public_path__ + "assets/images/help75a42ab0485c1ffcd343641303140dc3.svg";